const renderLi = (ctx, item, index, html) => html`
<li class="page-item ${item === ctx['current-page'] ? 'active' : ''}">
  <a class="page-link" href="#" @click="${ctx.clickHandler}" data-page-number="${item}">${item}</a>
</li>
`;

const renderRange = (ctx, item, index, html) => html`
  ${(item === ctx['current-page'] - ctx['visible-range']) || ctx.disabled ? html`
  <li class="page-item disabled">
    <a class="page-link" href="#"><span class="ai font-weight-bold">&hellip;</span></a>
  </li> <!-- prev ... -->
  `: html`${(item === ctx['current-page'] + ctx['visible-range']) || ctx.disabled ? html`
  <li class="page-item disabled">
    <a class="page-link" href="#"><span class="ai font-weight-bold">&hellip;</span></a>
  </li> <!-- next ... -->
  `: html`
  <!-- rest -->
  ${item > ctx['current-page'] - ctx['visible-range'] && item < ctx['current-page'] + ctx['visible-range'] ? html`
    ${renderLi(ctx, item, index, html)} `: '' } `} `}
`;

export default (ctx, html) => html`
${ctx['disable-links'] ? '' : html`
<nav>
  <ul class="pagination">
    ${ctx['disable-prev-next'] === false ? html`
    <li class="page-item ${(ctx['current-page'] <= 1) || ctx.disabled ? 'disabled' : ''}">
      <a data-bi-id="pagination-prev" tabIndex="${(ctx['current-page'] <= 1) || ctx.disabled ? '-1' : '0'}" class="page-link outline-focus-red" href="#" @click="${ctx.clickHandler}"
        data-page-number="${ctx['current-page'] - 1}">
        <slot name="prev-label"><span class="ai ai-chevron-left"></span></slot>
      </a></li>
    `: ''}

    ${ctx['disable-pages'] === false ? html`
      ${ctx['num-pages'].map((item, index) => html`
      ${index === 0 ? html`
      <!-- first item -->
      ${renderLi(ctx, item, index, html)}
      `: html`
      ${item === ctx['num-pages'].length ? html`
      <!-- last item -->
      ${renderLi(ctx, item, index, html)}` : html`
      <!-- in between -->
      ${renderRange(ctx, item, index, html)}
      `}
      `}
    `)}`: ''}

    ${ctx['disable-prev-next'] === false ? html`
    <li class="page-item ${(ctx['current-page'] >= ctx['num-pages'].length) || ctx.disabled ? 'disabled' : ''}">
      <a data-bi-id="pagination-next" tabIndex="${(ctx['current-page'] >= ctx['num-pages'].length) || ctx.disabled ? '-1' : '0'}" class="page-link outline-focus-red" href="#"
        @click="${ctx.clickHandler}" data-page-number="${ctx['current-page'] + 1}">
        <slot name="next-label"><span class="ai ai-chevron-right"></span></slot>
      </a></li>
    `: ''}
  </ul>
</nav>
`}
${ctx['enable-goto'] ? html`
<form @submit="${ctx.gotoSubmit}" novalidate>
  <label for="goto">
    <slot>Go To:</slot>
    <input id="goto" name="current-page" type="number" max="${ctx['num-pages'].length}" min="1" .value="${ctx['current-page']}">
    `: ''}
  </label>
  </form>
`;
